import type { FallbackProps } from 'react-error-boundary';

import { DefaultErrorPresenter } from './DefaultError.presenter';

export const DefaultErrorContainer: React.FC<FallbackProps> = ({
  resetErrorBoundary,
}) => {
  const reload = async () => {
    resetErrorBoundary();
  };

  return <DefaultErrorPresenter reload={reload} />;
};
